module.exports = __webpack_public_path__ + "static/img/pexels-rodrigo-santos-3888149@2x.856d06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/innovativeTechnology/pexels-rodrigo-santos-3888149@2x.png
// module id = 3n7/
// module chunks = 0